const VectorLine = (props: React.SVGProps<SVGSVGElement>) => (

    <svg {...props} width="218" height="34" viewBox="0 0 218 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_3_23)">
            <path d="M5 24C90.5853 -6.8382 136.517 2.03803 213 5.00001" stroke="#63B53D" stroke-width="3" />
        </g>
        <defs>
            <filter id="filter0_d_3_23" x="0.491516" y="0.0169449" width="216.567" height="33.3942" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3_23" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3_23" result="shape" />
            </filter>
        </defs>
    </svg>

);

export default VectorLine;
